import React, { useContext, useEffect, useState } from "react";
import classes from "./Details.module.css";
import Rating from "@mui/material/Rating";
import { toast } from "react-toastify";
import { MenuItem } from "@mui/material";
import { InputNumber } from "antd";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import paypal from "../../../assets/pay-pal.png";
import visa from "../../../assets/visa.png";
import mastercard from "../../../assets/master-card.png";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { FaFacebookF, FaPinterestP } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import AuthContext from "../../Common/authContext";
import { useDispatch, useSelector } from "react-redux";
import {
  updateSelectedVariants,
  updateSelectedVariantProduct,
  resetSelectedVariants,
  resetSelectedVariantProduct,
} from "../../redux/productSlice";
import NoVariants from "../../../assets/NoVariants.png";
import { IoBagAddOutline } from "react-icons/io5";
import { IoGitCompare } from "react-icons/io5";
import {
  addTocompare,
  editSearchData,
} from "../../redux/productSlice";
import { useNavigate } from '@hooks/useNavigate';
import axios from "axios";

const Details = () => {
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const authCtx = useContext(AuthContext);
  const currency = useSelector(
    (state) => state.products.selectedCurrency[0].currency
  );
  const navigate = useNavigate();
  const user = useSelector((state) => state.products.userInfo);
  const dispatch = useDispatch();
  const options = ["Option 1", "Option 2", "Option 3", "Option 4"];
  const [selectedOption, setSelectedOption] = useState("CATÉGORIES");
  const [searchQuery, setSearchQuery] = useState("");
  const [favorite, setfavorite] = useState(true);
  const [averageRating, setaverageRating] = useState(0);
  const favoriteData = useSelector((state) => state.products.favorites);
  const selectedBook = useSelector((state) => state.products.selectedBook[0]);
  const [categoryItem, setCategoryItem] = useState(null);

  const [count, setCount] = React.useState(1);
  
  const ROUTES = {
    allCat: '/',
    homeDecore: '/home-decore',
    clothes: '/clothes',
    cosmatics: '/cosmatics',
    islamic: '/islamic',
    library: '/library',
    kids: '/kids',
    food: '/food'
  };
  
  const routeItem = authCtx.articleFamille?.find(item => item.id === selectedBook.b_usr_articlecategorie_id);
  const route = routeItem?.route ;

  
  let isAllCat = route === ROUTES.allCat;
  let isHomeDecore = route === ROUTES.homeDecore;
  let isClothes = route === ROUTES.clothes;
  let isCosmatics = route === ROUTES.cosmatics;
  let isIslamic = route === ROUTES.islamic;
  let isLibrary = route === ROUTES.library;
  let isKids = route === ROUTES.kids;
  let isFood = route === ROUTES.food;

  const handleCountChange = (event) => {
    const value = Number(event.target.value);
    const maxQuantity = Number(resolvedAvailableQty);
    if (value < 1) {
      setCount(1);
    } else if (value < maxQuantity) {
      setCount(value);
    } else {
      setCount(Number(maxQuantity).toFixed(0));
    }
  };

  useEffect(() => {
    const calculateAverageRating = () => {
      if (
        !selectedBook.bookreview ||
        !Array.isArray(selectedBook.bookreview) ||
        selectedBook.bookreview.length === 0
      ) {
        return 0; // Return 0 if there are no reviews or if bookreview is not an array
      }

      const validRatings = selectedBook.bookreview?.filter(
        (review) => !isNaN(parseFloat(review.rate))
      );

      if (validRatings.length === 0) {
        return 0; // Return 0 if there are no valid ratings
      }

      const totalRatings = selectedBook.bookreview.reduce(
        (accumulator, review) => accumulator + parseFloat(review.rate),
        0
      );
      let reviewsCount = selectedBook.bookreview.length;

      return totalRatings / reviewsCount;
    };

    const averageRate = calculateAverageRating();
    setaverageRating(averageRate);
  }, [selectedBook]);

  useEffect(() => {
    {
      favoriteData.some((book) => book._favid === selectedBook.id)
        ? setfavorite(true)
        : setfavorite(false);
    }
  }, [selectedBook]);

  const FavoriteClick = () => {
    if (user?.id) {
      if (favorite) {
        authCtx.deleteFavorite(selectedBook.id);
      } else {
        authCtx.addToFavorite(selectedBook);
      }
      setfavorite(!favorite);
    } else {
      toast.error(`${language === 'eng' ? "Please login to add to wishlist." : "Veuillez vous connecter pour ajouter à votre liste de souhaits."}`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
    }
  };
  const numberOptions = Array.from({ length: 50 }, (_, index) => index + 1);

  const getToken = () => {
    return sessionStorage.getItem('token');
  };

  const token = getToken();
  
  
  const handleSuivreCollab = async () => {
    if (!user) {
        // If user is not defined, throw an error
        toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
        return;
    }

    try {
        // Fetch the list of collaborators
        const collaboratorsResponse = await axios.get(`${import.meta.env.VITE_TESTING_API}/collaborators?ecom_type=${import.meta.env.VITE_ECOM_TYPE}`);
        const collaborators = collaboratorsResponse.data;

        const cleanedAuteur = selectedBook.dc_auteur.trim();
        // Find the collaborator whose nom + prenom matches selectedBook.dc_auteur
        const collaborator = collaborators.find(collaborator => {
            const fullName = `${collaborator.nom}`;
            console.log(fullName.toLowerCase())
            console.log(cleanedAuteur.toLowerCase())
            return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
        });
        
        if (!collaborator) {
            throw new Error('Collaborator not found');
        }

        // Send the subscription request with the found collaborator's id
        const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/users/${user.id}/subscriptions`, {
            collaborator_id: collaborator.id,
            ecom_type: `${import.meta.env.VITE_ECOM_TYPE}`
        }, {
            headers: {
                Authorization: `Bearer ${token}` // Include token in the headers
            }
        });

        // console.log(response.data);
        toast.success(`${collaborator.nom} subscribed successfully!`, {hideProgressBar: true}); // You can handle the response here
    } catch (error) {
        // console.error('Error:', error);
        toast.error(error.response?.data?.error || error.message);
    }
};

const handleSuivreEditor = async () => {
  if (!user) {
      // If user is not defined, throw an error
      toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
      return;
  }

  try {
      // Fetch the list of collaborators
      const collaboratorsResponse = await axios.get(`${import.meta.env.VITE_TESTING_API}/collaborators?ecom_type=${import.meta.env.VITE_ECOM_TYPE}`);
      const collaborators = collaboratorsResponse.data;

      const cleanedAuteur = selectedBook?.dc_editor.trim();
      // Find the collaborator whose nom + prenom matches selectedBook.dc_auteur
      const collaborator = collaborators.find(collaborator => {
          const fullName = `${collaborator.nom}`;
          // console.log(fullName.toLowerCase())
          // console.log(cleanedAuteur.toLowerCase())
          return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
      });

      if (!collaborator) {
          throw new Error('Collaborator not found');
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/users/${user.id}/subscriptions`, {
          collaborator_id: collaborator.id,
          ecom_type: `${import.meta.env.VITE_ECOM_TYPE}`
      }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });

      // console.log(response.data);
      toast.success(`${language === 'eng' ? `${collaborator.nom} subscribed successfully!` : `${collaborator.nom} abonné avec succès !!`}`, {hideProgressBar: true}); // You can handle the response here
  } catch (error) {
      // console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message);
  }
};

const handleSuivreTranslator = async () => {
  if (!user) {
      // If user is not defined, throw an error
      toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
      return;
  }

  try {
      // Fetch the list of collaborators
      const collaboratorsResponse = await axios.get(`${import.meta.env.VITE_TESTING_API}/collaborators?ecom_type=${import.meta.env.VITE_ECOM_TYPE}`);
      const collaborators = collaboratorsResponse.data;

      const cleanedAuteur = selectedBook.dc_traducteur.trim();
      // Find the collaborator whose nom + prenom matches selectedBook.dc_auteur
      const collaborator = collaborators.find(collaborator => {
          const fullName = `${collaborator.nom}`;
          // console.log(fullName.toLowerCase())
          // console.log(cleanedAuteur.toLowerCase())
          return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
      });

      if (!collaborator) {
          throw new Error('Collaborator not found');
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/users/${user.id}/subscriptions`, {
          collaborator_id: collaborator.id,
          ecom_type: `${import.meta.env.VITE_ECOM_TYPE}`
      }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });

      // console.log(response.data);
      toast.success(`${language === 'eng' ? `${collaborator.nom} subscribed successfully!` : `${collaborator.nom} abonné avec succès !!`}`, {hideProgressBar: true}); // You can handle the response here
  } catch (error) {
      // console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message);
  }
};
const handleSuivreIllustrateur = async () => {
  if (!user) {
      // If user is not defined, throw an error
      toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
      return;
  }

  try {
      // Fetch the list of collaborators
      const collaboratorsResponse = await axios.get(`${import.meta.env.VITE_TESTING_API}/collaborators?ecom_type=${import.meta.env.VITE_ECOM_TYPE}`);
      const collaborators = collaboratorsResponse.data;

      const cleanedAuteur = selectedBook.dc_illustrateur.trim();
      // Find the collaborator whose nom + prenom matches selectedBook.dc_auteur
      const collaborator = collaborators.find(collaborator => {
          const fullName = `${collaborator.nom}`;
          // console.log(fullName.toLowerCase())
          // console.log(cleanedAuteur.toLowerCase())
          return fullName.toLowerCase() === cleanedAuteur.toLowerCase();
      });

      if (!collaborator) {
          throw new Error('Collaborator not found');
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/users/${user.id}/subscriptions`, {
          collaborator_id: collaborator.id,
          ecom_type: `${import.meta.env.VITE_ECOM_TYPE}`
      }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });

      // console.log(response.data);
      toast.success(`${language === 'eng' ? `${collaborator.nom} subscribed successfully!` : `${collaborator.nom} abonné avec succès !!`}`, {hideProgressBar: true}); // You can handle the response here
  } catch (error) {
      // console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message);
  }
};


const handleSuivreCollection = async () => {
  if (!user) {
      // If user is not defined, throw an error
      toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`);
      return;
  }

  try {
      // Fetch the list of collaborators
      const collectionsResponse = await axios.get(`${import.meta.env.VITE_TESTING_API}/collections?ecom_type=${import.meta.env.VITE_ECOM_TYPE}`);
      const collections = collectionsResponse.data;
      const cleanedCollec = selectedBook.dc_collection.trim();
      // Find the collaborator whose nom + prenom matches selectedBook.dc_auteur
      const Collectiondata = collections.find(collaborator => {
          const fullName = `${collaborator.nom}`;
          // console.log(fullName.toLowerCase())
          // console.log(cleanedCollec.toLowerCase())
          return fullName.toLowerCase() === cleanedCollec.toLowerCase();
      });

      if (!Collectiondata) {
          throw new Error('Collection not found');
      }

      // Send the subscription request with the found collaborator's id
      const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/users/${user.id}/subscriptions`, {
          collection_id: Collectiondata.id,
          ecom_type: `${import.meta.env.VITE_ECOM_TYPE}`
      }, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });

      // console.log(response.data);
      toast.success(`${language === 'eng' ? `${Collectiondata.nom} subscribed successfully!` : `${Collectiondata.nom} abonné avec succès !!`}`, {hideProgressBar: true}); // You can handle the response here
  } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.error || error.message);
  }
};

useEffect(() => {
  const foundItem = authCtx.categories.find(category => category.id === selectedBook.b_usr_articletheme_id);
  setCategoryItem(foundItem);
}, [selectedBook.b_usr_articletheme_id, authCtx.categories]);

const handleSuivreCategory = async () => {
  if (!user) {
    // If user is not defined, throw an error
    toast.error(`${language === 'eng' ? "Please log in first" : "Veuillez d'abord vous connecter"}`, {hideProgressBar: true});
    return;
}
  try {
    const response = await axios.post(`${import.meta.env.VITE_TESTING_API}/users/${user.id}/subscriptions`, {
      category_id: categoryItem?.id,
      ecom_type: `${import.meta.env.VITE_ECOM_TYPE}`
    }, {
      headers: {
          Authorization: `Bearer ${token}` // Include token in the headers
      }
  });
    // console.log(response.data);
    toast.success(`${language === 'eng' ? `${categoryItem?._nom} subscribed successfully!` : `${categoryItem._nom} abonné avec succès !!`}`, {hideProgressBar: true}) // You can handle the response here
  } catch (error) {
    // console.error('Error:', error);
    toast.error(error.response?.data?.error, {hideProgressBar: true})
  }
};


const [selectedVariants, setSelectedVariants] = useState({});
  const [article_variant_combination, setSelectedCombinationVariants] = useState({});
  const [selectedVariantProductValues, setSelectedVariantProductValues] = useState({});

  const variantProductFields = selectedBook?.variant_product?.variant_product_combine_fields || [];
  const variantProductRows = selectedBook?.variant_product?.variants || [];
  const hasVariantProduct = variantProductFields.length > 0 && variantProductRows.length > 0;

  const normalizeVariantText = (value) => String(value || "").trim().toLowerCase();

  const getVariantFieldNameById = (fieldId) => {
    const result = variantProductFields.find((field) => Number(field.id) === Number(fieldId))?.field_name;
    return normalizeVariantText(result);
  };

  const getVariantProductQty = (variantRow) => {
    return Number(variantRow?.product?._qte_a_terme_calcule || 0);
  };

  const getQtyFromObject = (obj) => {
    return Number(obj?._qte_a_terme_calcule || obj?.quantity || 0);
  };

  const extractProductCombination = (product) => {
    const combination = {};
    if (!product?.article_multi_products || !Array.isArray(product.article_multi_products)) return combination;
    product.article_multi_products.forEach((item) => {
      if (item?.lookup_multiproduct_parent && item?.lookup_multiproduct) {
        const rawFieldName = item.lookup_multiproduct_parent.nom_fr || item.lookup_multiproduct_parent.nom;
        const rawValue = item.lookup_multiproduct.nom_fr || item.lookup_multiproduct.nom;
        const fieldName = normalizeVariantText(rawFieldName);
        const value = normalizeVariantText(rawValue);
        if (!combination[fieldName]) combination[fieldName] = value;
      }
    });
    return combination;
  };

  const variantProductMatchesSelections = (variantRow, selections) => {
    if (!variantRow?.product) return false;
    const productCombination = extractProductCombination(variantRow.product);
    return Object.entries(selections).every(([fieldId, selectedItem]) => {
      if (!selectedItem) return true;
      const normalizedFieldName = getVariantFieldNameById(fieldId);
      if (!normalizedFieldName) return false;
      const selectedValue = normalizeVariantText(selectedItem?.display_text || selectedItem?.value);
      const productValue = productCombination[normalizedFieldName];
      return productValue === selectedValue;
    });
  };

  const getCompatibleVariantProducts = (selections) => {
    if (!hasVariantProduct) return [];
    return variantProductRows.filter((variantRow) =>
      variantProductMatchesSelections(variantRow, selections)
    );
  };

  const selectedCompatibleVariantProducts = getCompatibleVariantProducts(selectedVariantProductValues);

  const allVariantProductFieldsSelected =
    hasVariantProduct &&
    variantProductFields.every((field) => selectedVariantProductValues[field.id]);

  const selectedVariantProductRow = allVariantProductFieldsSelected
    ? selectedCompatibleVariantProducts.find((variantRow) => getVariantProductQty(variantRow) > 0) ||
      selectedCompatibleVariantProducts[0]
    : null;

  const selectedVariantProductQty = getVariantProductQty(selectedVariantProductRow);
  const selectedVariantProduct = selectedVariantProductRow?.product;
  const hasSelectedVariantProduct = Boolean(selectedVariantProduct?.id);

  const resolvedAvailableQty = hasVariantProduct
    ? (allVariantProductFieldsSelected ? selectedVariantProductQty : 0)
    : Number(getQtyFromObject(article_variant_combination) || selectedBook?._qte_a_terme_calcule || 0);

  // Reset selected variants when book changes
  useEffect(() => {
    setSelectedVariants({});
    setSelectedVariantProductValues({});
    dispatch(resetSelectedVariants());
    dispatch(resetSelectedVariantProduct());
  }, [selectedBook?.id, dispatch]);

  useEffect(() => {
    dispatch(updateSelectedVariantProduct(selectedVariantProductRow?.product || null));
  }, [dispatch, selectedVariantProductRow]);
  
  useEffect(() => {
    let finalPrice = (selectedBook?.price * 1); // Start with the base price
  
    // Check if all mandatory variants are selected
    const mandatoryVariants = selectedBook?.article_variants?.filter(v => v.is_mandatory);
    const allMandatorySelected = mandatoryVariants?.every(variant => selectedVariants[variant.id]);
  
    if (allMandatorySelected) {
      // If all mandatory variants are selected, look for the matching combination
      const selectedVariantItemIds = Object.values(selectedVariants)?.map(item => item.id);
      const matchingCombination = selectedBook?.article_variant_combinations.find(comb =>
        comb.combination_variant_items?.every(item =>
          selectedVariantItemIds.includes(item.b_usr_article_variant_item_id)
        )
      );
  
      if (matchingCombination) {
        // If a matching combination is found, add its price to the final price
        setSelectedCombinationVariants(matchingCombination)
        finalPrice += parseFloat(matchingCombination.price);
      }
    }
  
    // Iterate over each selected variant
    Object.keys(selectedVariants).forEach((variantId) => {
      const variant = selectedBook?.article_variants.find(v => v.id === parseInt(variantId));
      const selectedItem = selectedVariants[variantId];
      console.log('testt', selectedItem);
  
      if (!variant.is_mandatory) {
        if (variant.price_type === "change_price") {
          finalPrice = parseFloat(selectedItem.price);  // Replace the base price
        } else if (variant.price_type === "additional") {
          finalPrice += parseFloat(selectedItem.price);  // Add to the base price
        }
      }
    });
  
    // Update the price state with the calculated final price
    // setPrice(finalPrice);
  }, [selectedVariants, selectedBook]);
  
  const handleVariantSelect = (variantId, item) => {
    setSelectedVariants(prevState => {
      const updatedState = { ...prevState };
      setCount(1);
      if (updatedState[variantId] && updatedState[variantId].id === item.id) {
        delete updatedState[variantId];
      } else {
        const newVariant = selectedBook?.article_variants?.find(pv => pv.id === parseInt(variantId));
        const isNewVariantMandatory = newVariant?.is_mandatory;
        updatedState[variantId] = item;
        if (isNewVariantMandatory) {
          Object.keys(updatedState).forEach(prevVariantId => {
            if (parseInt(prevVariantId) === parseInt(variantId)) return;
            const prevSelectedVariant = updatedState[prevVariantId];
            const parentVariant = selectedBook?.article_variants?.find(pv => pv.id === parseInt(prevVariantId));
            const isMandatory = parentVariant?.is_mandatory;
            if (isMandatory) {
              const matchingCombinations = selectedBook?.article_variant_combinations?.filter(comb =>
                comb.combination_variant_items.some(combItem => combItem.b_usr_article_variant_item_id === item.id)
              );
              const matchingCombination = matchingCombinations.find(comb => {
                return comb.combination_variant_items.some(
                  combItem =>
                    combItem.b_usr_article_variant_item_id === prevSelectedVariant.id &&
                    comb.combination_variant_items.some(
                      newCombItem => newCombItem.b_usr_article_variant_item_id === item.id
                    )
                );
              });
              if (!matchingCombination) {
                delete updatedState[prevVariantId];
              }
            }
          });
        }
      }
      dispatch(updateSelectedVariants(updatedState));
      return updatedState;
    });
  };

  const handleVariantProductSelect = (fieldId, item) => {
    setCount(1);
    setSelectedVariantProductValues((prevState) => {
      const updatedState = { ...prevState };
      if (updatedState[fieldId] && updatedState[fieldId].id === item.id) {
        delete updatedState[fieldId];
        return updatedState;
      }
      updatedState[fieldId] = item;
      const compatible = getCompatibleVariantProducts(updatedState);
      const hasStock = compatible.some((row) => getVariantProductQty(row) > 0);
      if (!hasStock) {
        return { [fieldId]: item };
      }
      return updatedState;
    });
  };
  
  


  const AddtoBag = (props) => {
    const allMandatorySelected = (selectedBook?.article_variants || []).every((variant) => {
      if (variant.is_mandatory) {
        return selectedVariants[variant.id] !== undefined && selectedVariants[variant.id]?.id !== undefined;
      }
      return true;
    });

    if (!allMandatorySelected) {
      toast.error(`Please select all mandatory variants before submitting.`, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
        theme: "colored",
      });
      return;
    }

    if (hasVariantProduct && !allVariantProductFieldsSelected) {
      toast.error(
        `${language === "eng" ? "Please select all variant options before submitting." : "Veuillez sélectionner toutes les options de variante avant de continuer."}`,
        { position: "top-right", autoClose: 4000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: 0, theme: "colored" }
      );
      return;
    }

    if (hasVariantProduct && resolvedAvailableQty < 1) {
      toast.error(
        `${language === "eng" ? "Selected variant combination is out of stock." : "La combinaison de variantes sélectionnée est en rupture de stock."}`,
        { position: "top-right", autoClose: 4000, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: 0, theme: "colored" }
      );
      return;
    }

    if (Number(count) > Number(resolvedAvailableQty)) {
      toast.error(
        `${language === "eng" ? `Maximum available quantity is ${Number(resolvedAvailableQty).toFixed(0)}.` : `La quantité maximale disponible est ${Number(resolvedAvailableQty).toFixed(0)}.`}`,
        { position: "top-right", autoClose: 2500, hideProgressBar: true, closeOnClick: true, pauseOnHover: true, draggable: true, progress: 0, theme: "colored" }
      );
      setCount(Number(resolvedAvailableQty));
      return;
    }

    const variantProduct = selectedVariantProductRow?.product;

    const data = {
      ...props,
      ...(variantProduct ? {
        id: variantProduct.id,
        designation: variantProduct.designation || props.designation,
        _prix_public_ttc: variantProduct._prix_public_ttc ?? props._prix_public_ttc,
        _qte_a_terme_calcule: variantProduct._qte_a_terme_calcule,
        articleimage: variantProduct.articleimage?.length > 0 ? variantProduct.articleimage : props.articleimage,
        _code_barre: variantProduct._code_barre || props._code_barre,
      } : {}),
      items_quantity: Math.min(Number(count), Number(resolvedAvailableQty)),
      selectedvariants: selectedVariants,
      selected_variant_product_values: selectedVariantProductValues,
      selected_variant_product: variantProduct,
      parent_product: hasVariantProduct ? props : undefined,
      child_articles: props.child_articles || [],
      article_variant_combination: article_variant_combination,
    };
    authCtx.addToCart(data);
  };

  

  return (
    <>
      <div className={classes.contantContainer}>
        <div className={classes.contentss}>
          <div className={classes.header_Cont}>
            <h1 className={classes.contentssp}
              style={{
                color:'var(--secondary-color)',
                fontWeight: "600",
                fontSize: "calc(1.4rem + .3vw)",
                width: "80%",margin:"0"
              }} onClick={()=>console.log(selectedBook)
              }
            >
              {selectedBook.designation}
            </h1>

          </div>
          
          <p style={{ display: "flex", flexDirection: "row" ,margin:'0.3em 0'}}>
              <span
                style={{
                  color: "#868686",
                  fontSize: "calc(.7rem + 0.3vw)",
                  lineHeight: "100%",
                  paddingRight: "0.5em",
                  fontWeight: "500",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {language === "eng" ? "Sub-Category: " : "Sous-Categorie: "}

              </span>
              <span
                style={{
                  color: "#111",
                  fontSize: "calc(.8rem + 0.3vw)",
                  lineHeight: "100%",
                  fontWeight: "400",
                  display: "flex",textTransform:"capitalize"
                }}
              >
                {routeItem?.type_nom}
              </span>
            </p>
          
          <div className={classes.rating}>
              <Rating
                size="small"
                name="book-rate"
                readOnly
                value={averageRating}
                precision={0.5}
                //   value={selectedBook.rate}
                style={{
                  color: "#FAAF00",
                  width: "fit-content",
                  marginLeft: "auto",
                  textAlign: "left",
                  marginTop: "0.6em",
                }}
              />
              <p style={{ color: "#272E38" ,textWrap:'nowrap',marginTop:'0.6em',marginLeft:".5em"}}>
              <span style={{fontWeight:"700",paddingRight:'.5em'}}>{Number(selectedBook?.average_rate)?.toFixed(1)}</span>  {selectedBook?.bookreview?.length} {language === 'eng' ? "reviews" : "revues"}
              </p>
            </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <p>
              {" "}
              
              <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            margin: "0",
                            columnGap: "0.5em",
                          }}
                        >
                          <p
                            style={{
                              color: "#272E38",
                              fontSize: "calc(1.6rem + 0.4vw)",
                              lineHeight: "100%",
                              paddingRight: "0.5em",
                              fontWeight: "600",
                              display: "flex",
                              flexDirection: "row",
                              margin: " 0",
                            }}
                          >
                            {(() => {
                              const calcPrice = (price) => {
                                let nextPrice = Number(price || 0);
                                if (selectedBook.discount > 0) {
                                  nextPrice = nextPrice - nextPrice * (selectedBook.discount / 100);
                                }

                                if (currency === "eur") {
                                  return `${Number(nextPrice).toFixed(2)}€`;
                                }

                                return `${(Number(nextPrice) * authCtx.currencyRate).toFixed(2)}$`;
                              };

                              if (hasSelectedVariantProduct) {
                                return calcPrice(selectedVariantProduct?._prix_public_ttc);
                              }

                              if (
                                selectedBook?._prix_public_ttc_max != null &&
                                selectedBook?._prix_public_ttc_max !== selectedBook?._prix_public_ttc
                              ) {
                                return `${calcPrice(selectedBook?._prix_public_ttc)} - ${calcPrice(selectedBook?._prix_public_ttc_max)}`;
                              }

                              return calcPrice(selectedBook?._prix_public_ttc);
                            })()} {" "}
                          </p>
                          {selectedBook.discount > 0 && (
                            <p
                              style={{
                                color: "#868686",
                                textDecoration: "line-through",
                                fontSize: "calc(1rem + 0.3vw)",
                                margin: "auto 0",
                              }}
                            >
                              {currency === "eur"
                                ? `€ ${Number(hasSelectedVariantProduct ? selectedVariantProduct?._prix_public_ttc : selectedBook?._prix_public_ttc).toFixed(2)} `
                                : `$ ${(
                                  (hasSelectedVariantProduct ? selectedVariantProduct?._prix_public_ttc : selectedBook?._prix_public_ttc) * authCtx.currencyRate
                                  ).toFixed(2)} `}
                            </p>
                          )}
                          {selectedBook.discount > 0 && (
                            <p
                              style={{
                                color: "var(--secondary-color)",
                                fontSize: "calc(1rem + 0.3vw)",
                                margin: "auto 0",
                              }}
                            >
                              {selectedBook.discount}{language=== 'fr' ? "% de réduction" : "% off"}
                            </p>
                          )}
                        </span>
              
            </p>
          </div>
          
          {/* <div style={{ display: "flex", flexDirection: "row" }}>
            <p>
              {" "}
              <span
                style={{
                  color: "#111",
                  fontSize: "calc(.8rem + 0.3vw)",
                  lineHeight: "100%",
                  paddingRight: "0.5em",
                  fontWeight: "600",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                Original Price: 

              </span>{" "}
            </p>
            
              <p
                style={{
                  color: "rgba(159, 163, 166, 1)",
                  fontSize: "calc(.8rem + 0.3vw)",
                  lineHeight: "100%",
                  fontWeight: "500",
                  display: "flex",
                  textDecoration:selectedBook.discount > 0 &&  "line-through",
                }}
              >
                {currency === "eur"
                  ? ` ${(Number(selectedBook._prix_public_ttc).toFixed(2))}€`
                  : ` ${(
                      selectedBook._prix_public_ttc * authCtx.currencyRate
                    ).toFixed(2)}$`}
              </p>
          </div>
          
          <div style={{ display: "flex", flexDirection: "row",gap:'0 5em' }}>
            <p style={{ display: "flex", flexDirection: "row" ,margin:'0'}}>
              <span
                style={{
                  color: "#111",
                  fontSize: "calc(.8rem + 0.3vw)",
                  lineHeight: "100%",
                  paddingRight: "0.5em",
                  fontWeight: "600",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                Discount:

              </span>
              <span
                style={{
                  color: "#111",
                  fontSize: "calc(.8rem + 0.3vw)",
                  lineHeight: "100%",
                  fontWeight: "400",
                  display: "flex",
                }}
              >
                -{selectedBook.discount}%
              </span>
            </p>
            
            <p style={{ display: "flex", flexDirection: "row" ,margin:'0'}}>
              <span
                style={{
                  color: "#111",
                  fontSize: "calc(.8rem + 0.3vw)",
                  lineHeight: "100%",
                  paddingRight: "0.5em",
                  fontWeight: "600",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                EAN13

              </span>
              <span
                style={{
                  color: "#111",
                  fontSize: "calc(.8rem + 0.3vw)",
                  lineHeight: "100%",
                  fontWeight: "400",
                  display: "flex",
                }}
              >
                {selectedBook._code_barre}
              </span>
            </p>
          </div> */}

            {selectedBook?.article_variants?.map((variant) => {
  return (
    <div key={variant.id}>
      <p
        style={{
          fontWeight: '600',
          fontSize: 'calc(.8rem + .3vw)',
          marginBottom: '0.5em',color:"var(--accent-color)"
        }}
        onClick={() => console.log(selectedVariants)}
      >
        <span style={{color:"var(--secondary-color)"}}>{variant?.nom}</span> {' '}
        <span style={{ fontWeight: "400" }}>
          {/* {selectedVariants[variant.id]?.value} */}
          <span style={{color:"red"}}>{variant?.is_mandatory && "*"}</span>
        </span>
      </p>
      <div className={classes.selectVariant}>
        {variant.variant_items?.map((item) => {
  // Find all combinations that contain the current variant item
  const matchingCombinations = selectedBook?.article_variant_combinations?.filter(comb =>
    comb.combination_variant_items.some(combItem => combItem.b_usr_article_variant_item_id === item.id)
  );

  // Initialize availableQuantity
  let availableQuantity = 0;
  if (!variant.is_mandatory) {
    // If the variant is not mandatory, take the item's own quantity
    availableQuantity = item.quantity > 0 ? item.quantity : 0;
  } else{

  // Check if any items from other variant_ids are selected
  
  const selectedMandatoryVariants = Object.keys(selectedVariants)
  ?.map(key => ({ key, variant: selectedVariants[key] }))  // Map the objects by key
  ?.filter(({ variant }) => {
    const parentVariant = selectedBook?.article_variants?.find(pv => pv.id === variant.b_usr_article_variant_id);
    return parentVariant && parentVariant.is_mandatory;
  })
  .reduce((acc, { key, variant }) => {
    acc[key] = variant;  // Add the filtered variants back into an object using the original key
    return acc;
  }, {});

  const selectedOtherVariants = Object.keys(selectedMandatoryVariants)?.filter(variantId => 
    parseInt(variantId) !== variant.id
  );

  if (selectedOtherVariants.length === 0) {
    // No other variants are selected, sum all matching combinations' quantities
    availableQuantity = matchingCombinations.reduce((totalQty, comb) => {
      return totalQty + (comb.quantity > 0 ? comb.quantity : 0);
    }, 0);
  } else {
    // Some other variant items are selected, so filter combinations that match those
    matchingCombinations.forEach(comb => {
      // Check if all selected other variants match the combination items
      const isValidCombination = selectedOtherVariants?.every(variantId => {
        const selectedVariantItem = selectedVariants[variantId];

        // Find the corresponding combination item for the selected other variant
        const combItem = comb.combination_variant_items.find(item => item.variant_item.b_usr_article_variant_id == variantId);

        // Check if the combination item exists and matches the selected variant item
        return combItem && selectedVariantItem.id === combItem.b_usr_article_variant_item_id;
      });

      // If it's a valid combination and has quantity, add it to availableQuantity
      if (isValidCombination && comb.quantity > 0) {
        availableQuantity += comb.quantity;
      }
    });
  }
}
  // Determine if this item should be disabled based on available quantity
  const isVariantDisabled = availableQuantity <= 0;


          return (
            <div
              key={item.id}
              style={{
                position: 'relative',
                padding: item?.image ? '0' : '1.7em 1em',
                minWidth:"2.5em",
                textAlign:'center',
                // cursor: isVariantDisabled ? "not-allowed" : "pointer",
                cursor: "pointer",
                borderRadius: ".7vw",
                border: selectedVariants[variant.id]?.id === item.id
                  ? "2px solid var(--secondary-color)"
                  : "2px solid #D9D9D9",
                background: "#fff",overflow:'hidden',
                color:  "#272E38",
                opacity: isVariantDisabled ? 0.6 : 1,
                height: 'fit-content'
              }}
              onClick={(e) => {
                e.preventDefault();
                console.log(availableQuantity);
                  handleVariantSelect(variant.id, item);
              }}
            >
              {item?.image ? (
                <img
                  src={item.image}
                  alt=""
                  style={{
                    width: '4.5em',
                    height: '4.5em',
                    margin: '0',
                    padding: "0",
                    display: 'block'
                  }}
                />
              ) : (
                <p style={{ fontSize:'calc(.6rem + .3vw)', margin: '0' }}>
                  {item.value} 
                  {/* <span style={{color:"red"}}>{variant?.is_mandatory && "”"}</span>  */}
                </p>
              )}
              {isVariantDisabled && (
                <div className={classes.diagonaloverlay}>
                  <img src={NoVariants} alt="" style={{width:"100%",height:"100%"}}/>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
})}

          {selectedBook?.variant_product?.variant_product_combine_fields?.map((variant) => {
  return (
    <div key={variant.id}>
      <p
        style={{
          fontWeight: '600',
          fontSize: 'calc(.8rem + .3vw)',
          marginBottom: '0.5em',color:"var(--accent-color)"
        }}
      >
        <span style={{color:"var(--secondary-color)"}}>{variant?.field_name}</span>{' '}
        <span style={{color:"red"}}>{'*'}</span>
      </p>
      <div className={classes.selectVariant}>
        {variant.values?.map((item) => {
          const nextSelections = {
            ...selectedVariantProductValues,
            [variant.id]: item,
          };
          const compatibleRowsForItem = getCompatibleVariantProducts(nextSelections);
          const availableQuantity = compatibleRowsForItem.reduce(
            (sum, variantRow) => sum + Math.max(0, getVariantProductQty(variantRow)),
            0
          );
          const isVariantDisabled = availableQuantity <= 0;
          return (
            <div
              key={item.id}
              style={{
                position: 'relative',
                padding: item?.image ? '0' : '1.7em 1em',
                minWidth:"2.5em",
                textAlign:'center',
                cursor: "pointer",
                borderRadius: ".7vw",
                border: selectedVariantProductValues[variant.id]?.id === item.id
                  ? "2px solid var(--secondary-color)"
                  : "2px solid #D9D9D9",
                background: "#fff",overflow:'hidden',
                color: "#272E38",
                opacity: isVariantDisabled ? 0.6 : 1,
                height: 'fit-content'
              }}
              onClick={(e) => {
                e.preventDefault();
                handleVariantProductSelect(variant.id, item);
              }}
            >
              {item?.image ? (
                <img src={item.image} alt="" style={{width:'4.5em',height:'4.5em',margin:'0',padding:"0",display:'block'}} />
              ) : (
                <p style={{ fontSize:'calc(.6rem + .3vw)', margin: '0' }}>{item.display_text}</p>
              )}
              {isVariantDisabled && (
                <div className={classes.diagonaloverlay}>
                  <img src={NoVariants} alt="" style={{width:"100%",height:"100%"}}/>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
})}

          <div style={{display:"flex",flexDirection:"row",flexWrap:"wrap",margin:'1.5em 0',gap:"1em"}}>
          <p
                style={{
                  color: "var(--secondary-color)",
                  fontSize: "calc(.8rem + 0.3vw)",
                  lineHeight: "100%",
                  paddingRight: "0.5em",
                  fontWeight: "600",
                  display: "flex",
                  flexDirection: "row",textTransform:"uppercase",
                  margin:"auto 0"
                }}
              >
                {language === 'eng' ? 'Quantity' : 'Quantité'}
            </p>
            {/* <InputNumber
              min={1}
              value={count}
              onChange={value => handleCountChange({ target: { value } })}
              style={{
                margin: "0",
                height: "2.2em",
                backgroundColor: "#fff",
                borderRadius: ".5em"
              }}
              className={classes.inputt}
              disabled={selectedBook._qte_a_terme_calcule <= 0}
            /> */}
            
              <div className={classes.quantity}>
                <p
                  style={{
                    color: "var(--secondary-color)",
                    fontWeight: 500,
                      margin: "auto auto 0.2em auto",
                    fontSize: "20px",
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (count > 1) setCount(count - 1);
                  }}
                >
                  -
                </p>
                <p
                  style={{
                    color: "var(--secondary-color)",
                    fontWeight: 500,
                    height:"100%",
                    fontSize: "calc(1.2rem + 0.4vw)",
                    margin: "auto",
                    justifyContent:'center',
                  }}
                >
                  <input
                  type="number"
                  value={count}
                  onChange={handleCountChange}
                  style={{
                    color: "#272E38",
                      fontWeight: 500,
                      fontSize: "calc(.8rem + 0.3vw)",
                      margin: "0.2em auto auto auto",
                      justifyContent:'center',
                      width: "100%",
                      textAlign: "center",
                      backgroundColor: "transparent",
                      border: "none",
                      outline: "none",
                    }}
                  />
                </p>
                <p
                  style={{
                    color: "var(--secondary-color)",
                    fontWeight: 500,
                      margin: " auto auto",
                    fontSize: "calc(1.2rem + 0.4vw)",
                    cursor: Number(count) >= Number(resolvedAvailableQty) ? 'not-allowed' : 'pointer',
                    opacity: Number(count) >= Number(resolvedAvailableQty) ? '0.3' : '1',
                  }}
                  onClick={() => {
                    const maxQuantity = Number(resolvedAvailableQty);
                    if (Number(count) < maxQuantity) setCount(count + 1);
                  }}
                >
                  +
                </p>
              </div>
           <p style={{fontSize: "calc(.6rem + 0.3vw)", margin: "auto 0", color: hasVariantProduct && !allVariantProductFieldsSelected ? "#868686" : resolvedAvailableQty > 0 ? "#2DB224" : "#EE5858", fontWeight:"600" }}>
            {hasVariantProduct && !allVariantProductFieldsSelected
              ? (language === 'eng' ? 'Select all options' : 'Sélectionnez toutes les options')
              : resolvedAvailableQty > 0
                ? (language === 'eng' ? 'IN STOCK' : 'EN STOCK')
                : (language === 'eng' ? 'OUT OF STOCK' : 'HORS STOCK')
            }
          </p>
       </div>
          </div>
        
        <div className={classes.payment}>
          <div className={classes.bottonsContainer}>
            {resolvedAvailableQty > 0 ? <button
              onClick={(event) => {
                event.stopPropagation();
                AddtoBag(selectedBook);
              }}
              style={{ fontWeight: "400", cursor: resolvedAvailableQty > 0 ? authCtx.isLoading ? "wait" : 'pointer' : "not-allowed" }}
              className={classes.button}
              disabled={resolvedAvailableQty < 1 || authCtx.isLoading}
            >
              <IoBagAddOutline style={{marginRight:'.3em'}}/>
              {language === "eng" ? "Add to Cart" : " Ajouter au panier"}
            </button> : <div/>}
            <div className={classes.favoriteBtn} onClick={FavoriteClick}>
              {favorite ? (
                <FavoriteIcon
                  style={{
                    color: "var(--primary-color)",margin:'auto',fontSize:'1.5em',
                  }}
                />
              ) : (
                <FavoriteBorderIcon
                  style={{
                    color: "var(--primary-color)",margin:'auto',fontSize:'1.5em'
                  }}
                />
              )}
            </div>
                      <div
                        className={classes.favoriteBtn}
                        onClick={(event) => {
                          if (
                            !compareData.some(
                              (item) => item._comid === selectedBook.id
                            )
                          ) {
                            dispatch(
                              addTocompare({
                                _comid: selectedBook.id,
                                comtitle: selectedBook.designation,
                                comimage: selectedBook.articleimage?.[0]?.link,
                                comprice: selectedBook.prixpublic,
                                comquantity: 1,
                                comdescription: selectedBook.descriptif,
                                comDisponibilité: selectedBook.Disponibilité,
                                comauthor: selectedBook.dc_auteur,
                                comTraducteur: selectedBook.dc_traducteur,
                                comIllustrateur: selectedBook.Illustrateur,
                                comCollection: selectedBook.dc_collection,
                                comEditeur: selectedBook.dc_isbn_editeur,
                                comNbPages: selectedBook.nbpages,
                                comDimensions: `${selectedBook.hauteur} x ${selectedBook.largeur} x ${selectedBook.epaisseur} `,
                                comCouverture: selectedBook.Couverture,
                                comdate: selectedBook.dc_parution,
                                comPoids: selectedBook._poids_net,
                                comstock:selectedBook.article_stock,
                              })
                            );
                            event.stopPropagation();
                          } else {
                            toast.error(`${language === 'eng' ? `${props.designation} is already added` : `${props.designation} est déjà ajouté`}`, {
                              position: "top-right",
                              autoClose: 1500,
                              hideProgressBar: true,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: 0,
                              theme: "colored",
                            });
                            event.stopPropagation();
                          }
                        }}
                      >
                        <IoGitCompare style={{color: "var(--primary-color)",fontSize:'1.5em',margin:'auto'}}/>
                      </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Details;
